/** Constructeur lu dans les 3 premiers caractères du VIN (WMI) — même table que
 *  sb_pretransfer.VIN_BRANDS. */
export const VIN_BRANDS: Record<string, string> = {
  VF3: "PEUGEOT", VR3: "PEUGEOT",
  VF7: "CITROEN", VR7: "CITROEN",
  W0L: "OPEL", W0V: "OPEL", VXK: "OPEL", VXE: "OPEL",
};

/** La marque qui décide du site et du code ServiceBox : celle du VIN, sinon la saisie.
 *  Une marque vide, fausse ou « DS » envoyait le RDV sur le site Peugeot, où les
 *  campagnes d'une Citroën n'apparaissent pas (Héric, 2026-10-15). */
export function vehicleMarque(vehicle: { vin?: string | null; marque?: string | null } | null | undefined): string {
  const vin = (vehicle?.vin || "").replace(/\s/g, "").toUpperCase();
  return VIN_BRANDS[vin.slice(0, 3)] || vehicle?.marque || "";
}
